import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './ProductDetail.css';

const ProductDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  
  // Product data (same as ProductShowcase)
  const products = [
    {
      id: 1,
      name: 'HEMA-CORDIAL',
      category: 'womens-health',
      rating: 4.9,
      reviews: 245,
      badge: 'Best Seller',
      benefits: ['Menstrual Disorders', 'Uterine Tonic', 'Natural Sedative'],
      description: 'Unique remedy for menstrual complaints and functional uterine bleeding. Contains Asoka Bark, Ashwagandha, Lodhra, Shatavari.',
      dosage: '10-20ml twice daily before meals',
      packing: '200ml & 400ml bottles',
      image: '/photos/hema_coridal.jpeg'
    },
    {
      id: 2,
      name: 'GASSO-WIN',
      category: 'digestive-health',
      rating: 4.7,
      reviews: 189,
      badge: 'G.M.P. Certified',
      benefits: ['Gastric Relief', 'Digestive Stimulant', 'Liver Tonic'],
      description: 'Pure herbal syrup for gastric complaints with 18 herbal ingredients including Mustak, Pudina, Arjun, Haritaki.',
      dosage: '10-20ml twice daily after meals',
      packing: '200ml & 400ml bottles',
      image: '/photos/gasso_win.jpeg'
    },
    {
      id: 3,
      name: 'VITAL COMPOUND',
      category: 'liver-health',
      rating: 4.8,
      reviews: 167,
      badge: 'Popular',
      benefits: ['Appetite Improvement', 'Mental Vitality', 'Immune Support'],
      description: 'Natural herbal restorative tonic with adaptogens including Moosli Safed, Ashwagandha, Satawari, Honey.',
      dosage: '10ml before or after principal meals',
      packing: '200ml & 400ml bottles',
      image: '/photos/vital_compounds.jpeg'
    },
    {
      id: 4,
      name: 'COUGH-CO',
      category: 'respiratory-care',
      rating: 4.6,
      reviews: 203,
      badge: null,
      benefits: ['Cough Relief', 'Bronchitis Care', 'Sore Throat'],
      description: 'Time-tested herbal cough syrup with Vasaka, Madhuyashti, Tulsi, Honey for respiratory issues.',
      dosage: 'Adults: 5-10ml 2-3 times daily; Children: 2.5-5ml',
      packing: '100ml bottle',
      image: '/photos/cough_co.jpeg'
    },
    {
      id: 5,
      name: 'LIVWIN',
      category: 'liver-health',
      rating: 4.5,
      reviews: 134,
      badge: null,
      benefits: ['Liver Detox', 'Jaundice Care', 'Hepatoprotective'],
      description: 'Powerful herbal liver tonic with Bhumyamalaki, Bhringraj, Punarnava, Guduchi for liver health.',
      dosage: '5-10ml twice daily',
      packing: '100ml & 200ml bottles',
      image: '/photos/livwin_syrup.jpeg'
    },
    {
      id: 6,
      name: 'ACHE-WIN OIL',
      category: 'pain-relief',
      rating: 4.4,
      reviews: 178,
      badge: 'Topical',
      benefits: ['Muscular Pain', 'Arthritis Relief', 'Anti-inflammatory'],
      description: 'Herbal pain-relieving massage oil with Jyotismati, Vanharidra, Rasna in Sesame oil base.',
      dosage: 'Apply and massage 2-3 times daily (External use only)',
      packing: '25ml & 50ml bottles',
      image: '/photos/ache_win.jpeg'
    },
    {
      id: 7,
      name: 'VITAL DROPS (Pediatric)',
      category: 'pediatric-care',
      rating: 4.7,
      reviews: 92,
      badge: 'Kids Safe',
      benefits: ['Liver Tonic', 'Growth Support', 'Mental Development'],
      description: 'Pediatric liver tonic with Punarnava, Guduchi, Brahmi, Shankhpushpi for healthy growth.',
      dosage: 'Infants: 5-10 drops; Children: 10-20 drops, three times daily',
      packing: '60ml bottle',
      image: '/photos/vital_drops.jpeg'
    },
    {
      id: 8,
      name: 'DYLOWIN TABLET',
      category: 'diabetes-care',
      rating: 4.8,
      reviews: 156,
      badge: 'Anti-Diabetic',
      benefits: ['Blood Sugar Control', 'Insulin Sensitivity', 'Diabetic Complications'],
      description: 'Herbal anti-diabetic formulation with 24 ingredients including herbs and mineral bhasmas.',
      dosage: '1-2 tablets twice daily',
      packing: '50 tablets bottle',
      image: '/photos/dylowin.jpeg'
    }
  ];

  // Try to get product from location state first, then from products array by ID
  let product = location.state?.product;
  if (!product && id) {
    product = products.find(p => p.id === parseInt(id));
  }

  if (!product) {
    return (
      <div className="product-detail-error">
        <h2>Product not found</h2>
        <button onClick={() => navigate('/')} className="btn btn-primary">
          Go Back Home
        </button>
      </div>
    );
  }

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={i} className="star filled">★</span>
      );
    }

    if (hasHalfStar) {
      stars.push(
        <span key="half" className="star half">★</span>
      );
    }

    const remainingStars = 5 - stars.length;
    for (let i = 0; i < remainingStars; i++) {
      stars.push(
        <span key={`empty-${i}`} className="star empty">★</span>
      );
    }

    return stars;
  };

  return (
    <div className="product-detail-page">
      <div className="container">
        <button onClick={() => navigate(-1)} className="back-button">
          ← Back to Products
        </button>
        
        <div className="product-detail-content">
          <div className="product-detail-image">
            {product.image ? (
              <img src={product.image} alt={product.name} />
            ) : (
              <div className="product-image-placeholder">
                <span>🌿</span>
              </div>
            )}
          </div>
          
          <div className="product-detail-info">
            <div className="product-detail-header">
              <h1 className="product-detail-name">{product.name}</h1>
              {product.badge && (
                <span className={`product-badge product-badge-details ${product.badge.toLowerCase().replace(' ', '-')}`}>
                  {product.badge}
                </span>
              )}
            </div>
            
            <div className="product-rating">
              <div className="stars">
                {renderStars(product.rating)}
              </div>
              <span className="rating-text">
                {product.rating} ({product.reviews} reviews)
              </span>
            </div>

            <div className="product-description">
              <h3>Description</h3>
              <p>{product.description}</p>
            </div>

            <div className="product-benefits">
              <h3>Benefits</h3>
              <ul>
                {product.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>

            <div className="product-details">
              <div className="detail-section">
                <h3>Usage Instructions</h3>
                <div className="detail-item">
                  <strong>Dosage:</strong>
                  <span>{product.dosage}</span>
                </div>
              </div>
              
              <div className="detail-section">
                <h3>Availability</h3>
                <div className="detail-item">
                  <strong>Available in:</strong>
                  <span>{product.packing}</span>
                </div>
              </div>
            </div>

            <div className="product-actions">
              <button 
                className="btn btn-primary" 
                onClick={() => window.open(`/contact.html?product=${encodeURIComponent(product.name)}&id=${product.id}`, '_blank')}
              >
                Contact for Price
              </button>
              {/* <button className="btn btn-outline">Add to Wishlist</button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;